<template>
  <div>
    <div class="flex justify_between dashboard_header pa2" ref="topOfDashboard">
      <b class="mt1 mya">{{ $t('cms.dashboard.Header') }}</b>
      <span class="arrow-icon-wrapper">
        <toggle-arrow
          class="mya"
          :value="isShowingAllGraphs"
          @input="toggleShowAllGraphs"
          dark
        />
      </span>
    </div>

    <!--
    min height here to prevent the collapse from
    temporarily collapsing when switching graphs
     -->
    <div class="my2 pa2 dashboard-graph">
      <collapse
        flexible-height
        v-for="(graphData, index) in allGraphData"
        :delay-on-enter="isShowingAllGraphs ? 100 * index : null"
        :delay-on-leave="isShowingAllGraphs ? 50 * index : null"
        :key="graphData.key"
        :value="graphData.display"
      >
        <hr v-if="isShowingAllGraphs && index > 0" class="my4 dashed"/>
        <!--
        Min height here to prevent graph from sometimes not appearing on iOS
         -->
        <graph :graphData="graphData" style="min-height: 150px;"/>
      </collapse>
    </div>

    <metrics
      class="dashboard-metrics"
      clickable
      :value="selectedMetrics"
      @input="selectMetrics"
      :stats="stats"
    />
  </div>
</template>

<script>
import isElement from 'lodash/isElement';
import Graph from './Graph.vue';
import Metrics from '../Metrics.vue';
import MODELS from '../../constants/models';

export default {
  name: 'dashboard-data',

  components: { Metrics, Graph },

  data() {
    return {
      // User input variables:
      // array of this.$CONSTANTS.metrics.key
      metricsBeforeSelectAll: [this.$CONSTANTS.metrics[0].key],
      // array of this.$CONSTANTS.metrics.key
      selectedMetrics: [this.$CONSTANTS.metrics[0].key],

      // Set by frontend
      GRAPH_METRICS: this.$CONSTANTS.metrics.filter(metric => metric.includeInGraph),

      // Data from server:
      stats: MODELS.stats,
      statsPerHour: [],

      intervalHandler: null,
    };
  },

  computed: {
    allGraphData() {
      if (!(this.statsPerHour && this.statsPerHour.length > 0)) {
        return [];
      }

      return this.GRAPH_METRICS.map(metric => ({
        ...metric,
        statsPerHour: this.statsPerHour
          .map(data => ({ value: data[metric.key], hour: data.hour })),
        // Should it be displayed?
        display: this.selectedMetrics.includes(metric.key),
      }));
    },

    isShowingAllGraphs() {
      return this.selectedMetrics.length === 3;
    },
  },

  created() {
    this.$bus.$on('scroll-to-top', () => {
      this.scrollToElement(this.$refs.topOfDashboard);
    });

    this.fetchData();

    // Update data every 30 seconds
    this.intervalHandler = setInterval(this.fetchData, 1000 * 30);
  },

  destroyed() {
    clearInterval(this.intervalHandler);
    this.$bus.$off('scroll-to-top');
  },

  methods: {
    async fetchData() {
      const { data } = await this.$query(this.$queries.dashboardStats);
      const { realtimeStats, stats } = data || {};

      this.stats = stats || this.stats;
      this.statsPerHour = realtimeStats || this.statsPerHour;
    },

    selectMetrics(value) {
      if (this.isShowingAllGraphs) {
        // jump to top of campaigns on dashboard
        this.$bus.$emit('scroll-to-top');
      }
      this.selectedMetrics = value;
    },

    toggleShowAllGraphs() {
      if (this.isShowingAllGraphs) {
        this.selectedMetrics = this.metricsBeforeSelectAll;
      } else {
        this.metricsBeforeSelectAll = this.selectedMetrics;
        this.selectedMetrics = this.GRAPH_METRICS.map(metric => metric.key);
      }
    },

    scrollToElement(el) {
      if (isElement(el)) {
        el.scrollIntoView();
        window.scrollBy(0, -6); // scroll to the default margin above the point
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.dashboard_header {
  background-color: $color_background_light_blue;
}

.arrow-icon-wrapper {
  background-color: black !important;
  border-radius: 99px;
  border: unset;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 24px;
  width: 48px;
}

.dashboard-graph {
  min-height: 150px;
  overflow: hidden;
  position: relative;
  z-index: 1
}

.dashboard-metrics {
  position: relative;
  z-index: 2;
}
</style>
